import {app} from '../../../../../../app';
import {Controller} from './on-premises-form.controller';

app.component('directoryIntegrationOnPremisesForm', {
    bindings: {
        companyId: '<',
        directoryId: '<',
        initialValue: '<',
        onSave: '&',
    },
    controller: Controller,
    templateUrl: require('./on-premises-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/on-premises-form/on-premises-form.component.js